import { useQuery } from "@tanstack/react-query";

import { useIntegrationApi } from "lib/integrationApiContext";

/**
 * The values a mapped CRM field accepts, for the send form's dropdowns.
 *
 * Keyed on the field rather than the lead, because the answer depends only on the company's CRM —
 * so opening the form for a second lead reuses what the first one fetched.
 */
export function useCrmFieldOptions(entityName: string, fieldName: string, enabled: boolean) {
  const api = useIntegrationApi();

  return useQuery(
    ["dynamicsFieldOptions", entityName, fieldName],
    async () => {
      const { values } = await api.leadFieldOptions({
        leadFieldOptionsRequest: { entityName, fieldName },
      });
      return values;
    },
    {
      enabled,
      // The set of stages a CRM offers changes about as often as its schema does.
      staleTime: Infinity,
      // An empty dropdown is worse than a text box, so a failure leaves the field as free text.
      retry: false,
    },
  );
}
